// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","Panel":"bel_a bie_ea bie_ke bie_ju bie_sn bie_wl"};